import { Endpoint } from '../endpoint';

export const ReferenceValue = new Endpoint('reference_value');
